var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('breadcrumb',{attrs:{"items":_vm.breadcrumbs}})],1)],1),_c('activity-logs-table',{attrs:{"url":'/activity-logs'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }